import { Collapse } from "antd";
import { useMemo, useState } from "react";
import "./filters.css";
import ActionButton from "../actionButton";
import type { FiltersType, KeyOptionsType } from "./FiltersType";
import FiltersHeader from "./_ui/FiltersHeader";
import SelectedFilters from "./_ui/SelectedFilters";

const { Panel } = Collapse;

const Filters: React.FC<FiltersType> = ({
    appliedFilters,
    setAppliedFilters,
    currentAvailableFilters,
    needApplyButton = false,
    ignoredFilter,
    setIgnoredFilter,
    updateFilter,
    handleApply,
    defaultOpenKeys,
}) => {
    const [isFilterPanelOpen, setIsFilterPanelOpen] = useState<boolean>(true);
    const [currentOpenedFilterKeys, setCurrentOpenedFilterKeys] = useState<KeyOptionsType[]>(defaultOpenKeys);

    const allCurrentOpenedFilters = useMemo(() =>
        currentAvailableFilters
            .filter(f => currentOpenedFilterKeys.includes(f.key)),
        [currentAvailableFilters, currentOpenedFilterKeys]);

    const resetFilters = () => {
        const keysToRemove = currentAvailableFilters.map(f => f.key);

        setAppliedFilters(prev =>
            prev.filter(f => !keysToRemove.includes(f.key))
        );
    };

    return (
        <Collapse activeKey={isFilterPanelOpen ? "1" : ""} onChange={() => setIsFilterPanelOpen(prev => !prev)}>
            <Panel key="1"
                header={
                    <FiltersHeader
                        isFilterPanelOpen={isFilterPanelOpen}
                        currentAvailableFilters={currentAvailableFilters}
                        currentOpenedFilterKeys={currentOpenedFilterKeys}
                        setCurrentOpenedFilterKeys={setCurrentOpenedFilterKeys}
                    />
                }
            >
                <div className="filters">
                    <SelectedFilters
                        appliedFilters={appliedFilters}
                        allCurrentOpenedFilters={allCurrentOpenedFilters}
                        ignoredFilter={ignoredFilter}
                        setIgnoredFilter={setIgnoredFilter}
                        updateFilter={updateFilter}
                    />
                    <div>
                        {needApplyButton &&
                            <ActionButton text="Apply"
                                className="primary-btn-color"
                                styles={{ marginRight: "var(--spacing-sm)" }}
                                onClick={handleApply}
                            />
                        }
                        <ActionButton text="Clear" className="primary-btn-color" onClick={resetFilters} />
                    </div>
                </div>
            </Panel>
        </Collapse>
    )
}

export default Filters;
